// extracted by mini-css-extract-plugin
export default {"wrap":"ClientDetail_wrap__fqb95","top":"ClientDetail_top__Jb4xu","top_title":"ClientDetail_top_title__JVT9p","top_buttons":"ClientDetail_top_buttons__p0HTR"};